const {h, render, Component} = require('preact')
const WidgetView = require('../../views/main/widgets')
const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')
const ErrorView = require('../main/error')

class Widgets extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let url = `${Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/widgets`;
        if(this.props.isFaq == "true") url += "?isFAQ=true"
        let errorCb = (response) => {
            this.setState({widgets: null, 'isFailure': true});
        }
        let successCb = (response) => {
            if (response) {
                this.setState({widgets: response.widgets});
            }
        }
        SupportAPIHelper.get(url, null, successCb, errorCb, false);
    }

    render() {
        if (this.state.isFailure)
            return <ErrorView/>
        return (
            <WidgetView widgets = {this.state.widgets} />
        )
    }
}

module.exports = Widgets
